var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoricalTransformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49414 10.5V14.5",
    stroke: "#272C55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49414 14.5H11.4941",
    stroke: "#272C55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49414 12.5L12.4941 14.5",
    stroke: "#272C55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49414 16.5L12.4941 14.5",
    stroke: "#272C55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 0.0351562C5.911 0.0351562 7.358 0.797156 7.358 1.73516C7.358 2.67316 5.91 3.43516 4.125 3.43516C2.34 3.43516 0.891 2.67516 0.891 1.73516C0.891 0.795156 2.339 0.0351562 4.125 0.0351562ZM0.891 5.72516V7.03516C1.466 9.33516 7.15 8.88816 7.359 6.91716V5.61716C7.075 7.77216 1.346 7.92816 0.891 5.72516ZM0.875 2.32516V3.60116C1.45 5.84416 7.166 5.54116 7.375 3.61716V2.34216C7.09 4.45516 1.33 4.47716 0.875 2.32516ZM0.875 3.97316V5.27916C1.45 7.57916 7.166 7.26616 7.375 5.29516V3.99516C7.09 6.15416 1.33 6.17616 0.875 3.97316Z",
    fill: "#272D55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 11.2266C19.536 11.2266 20.983 11.9886 20.983 12.9266C20.983 13.8646 19.535 14.6266 17.75 14.6266C15.965 14.6266 14.516 13.8666 14.516 12.9266C14.516 11.9866 15.964 11.2266 17.75 11.2266ZM14.516 16.9166V18.2266C15.091 20.5266 20.775 20.0796 20.984 18.1086V16.8086C20.7 18.9636 14.971 19.1196 14.516 16.9166ZM14.5 13.5166V14.7926C15.075 17.0356 20.791 16.7326 21 14.8086V13.5336C20.715 15.6466 14.955 15.6686 14.5 13.5166ZM14.5 15.1646V16.4706C15.075 18.7706 20.791 18.4576 21 16.4866V15.1866C20.715 17.3456 14.955 17.3676 14.5 15.1646Z",
    fill: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoricalTransformation);
export default __webpack_public_path__ + "static/media/CategoricalTransformation.5114f1d7824241e8abed348c3f287d57.svg";
export { ForwardRef as ReactComponent };